import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useImmer } from 'use-immer'
import ShimmeringEffect from '../../components/shimmering/ShimmeringEffect'
import { replaceString } from '../../lib/AllGlobalFunction'
import { _orderStatus_, isSellerPanel } from '../../lib/AllStaticVariables'
import axiosProvider from '../../lib/AxiosProvider'

const OrderChart = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [data, setData] = useImmer({
    order: {},
    orderData: []
  })

  const getOrderColor = (key) => {
    let color = ''

    switch (key) {
      case 'pending':
        color = '#205d92'
        break
      case 'confirmed':
        color = '#4caf50'
        break
      case 'partialConfirmed':
        color = '#8bc34a'
        break
      case 'packed':
        color = '#2196f3'
        break
      case 'partialPacked':
        color = '#64b5f6'
        break
      case 'shipped':
        color = '#9c27b0'
        break
      case 'partialShipped':
        color = '#ce93d8'
        break
      case 'delivered':
        color = '#3aa1d7'
        break
      case 'partialDelivered':
        color = '#fff176'
        break
      case 'cancelled':
        color = '#ff5722'
        break

      case 'replaced':
        color = '#ff9800'
        break

      case 'returned':
        color = '#c62828'
        break

      case 'exchanged':
        color = '#ff5722'
        break

      case 'inExisting':
        color = '#2c799e'
        break

      case 'inRequest':
        color = '#41d1bc'
        break

      case 'inactivate':
        color = '#a368ed'
        break

      case 'totalActiveStocks':
        color = '#3aa1d7'
        break

      case 'totalStocks':
        color = '#205d92'
        break
      case 'unique':
        color = '#c3cdeb'
        break

      default:
        break
    }
    return color
  }

  const fetchData = async (days = 'All') => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'GET',
        endpoint: isSellerPanel
          ? 'Seller/Dashboard/getOrderCounts'
          : 'Dashboard/getOrderCounts',
        queryString: `?days=${days}`
      })

      setLoading(false)

      if (response?.status === 200) {
        let orderData = Object.entries(response?.data?.data).reduce(
          (arr, [key, value]) => {
            if (key !== 'totalOrders') {
              arr.push({
                name: replaceString(key),
                value,
                color: getOrderColor(key)
              })
            }
            return arr
          },
          []
        )
        setData((draft) => {
          draft.order = response?.data?.data
          draft.orderData = orderData
        })
      }
    } catch {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return loading ? (
    <ShimmeringEffect />
  ) : (
    <div
      style={{ boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }}
      className='pv-dashbord-chart-col'
    >
      <Row className='w-100 m-auto py-3'>
        <Col md={12}>
          <Row className='gy-3 p-3'>
            <Col md={12}>
              <div className='text-center'>
                <h2 className='cfz-26 fw-600'>Order Status</h2>
              </div>
            </Col>
            <Col md={12}>
              <div className='pv-allorder-status'>
                <div
                  role='button'
                  onClick={() => {
                    navigate(`/order?status=${_orderStatus_?.placed}`)
                  }}
                  className='border rounded text-center badge bg-Placed px-2  h-100 d-flex align-items-center justify-content-center flex-column'
                >
                  <h3 className='fw-600 mb-0 cfz-24 mb-0 text-black'>
                    {data?.order?.pending}
                  </h3>
                  <p className='mb-0 cfz-18 text-black'>Placed</p>
                </div>
                <div
                  role='button'
                  className='pv-orderstatus-inner text-center px-2 '
                  onClick={() => {
                    navigate(`/order?status=${_orderStatus_?.confirmed}`)
                  }}
                >
                  <h3 className='fw-600 mb-0 cfz-18 badge bg-Confirmed '>
                    {data?.order?.confirmed}
                  </h3>
                  <p className='mb-0'>Confirmed</p>
                </div>
                <div
                  role='button'
                  className='pv-orderstatus-inner text-center px-2 '
                  onClick={() => {
                    navigate(`/order?status=${_orderStatus_?.packed}`)
                  }}
                >
                  <h3 className='fw-600 mb-0 cfz-18 badge bg-Packed '>
                    {data?.order?.packed}
                  </h3>
                  <p className='mb-0'>Packed</p>
                </div>
                <div
                  role='button'
                  className='pv-orderstatus-inner text-center px-2 '
                  onClick={() => {
                    navigate(`/order?status=${_orderStatus_?.ship}`)
                  }}
                >
                  <h3 className='fw-600 mb-0 cfz-18 badge bg-Shipped '>
                    {data?.order?.shipped}
                  </h3>
                  <p className='mb-0'>Shipped</p>
                </div>
                <div
                  role='button'
                  className='pv-orderstatus-inner text-center px-2 '
                  onClick={() => {
                    navigate(`/order?status=${_orderStatus_?.delivered}`)
                  }}
                >
                  <h3 className='fw-600 mb-0 cfz-18 badge bg-Delivered '>
                    {data?.order?.delivered}
                  </h3>
                  <p className='mb-0'>Delivered</p>
                </div>
                <div
                  role='button'
                  className='pv-orderstatus-inner text-center px-2 '
                  onClick={() => {
                    navigate(`/order?status=${_orderStatus_?.replaced}`)
                  }}
                >
                  <h3 className='fw-600 mb-0 cfz-18 badge bg-Replaced '>
                    {data?.order?.replaced}
                  </h3>
                  <p className='mb-0'>Replaced</p>
                </div>
                <div
                  role='button'
                  className='pv-orderstatus-inner text-center px-2 '
                  onClick={() => {
                    navigate(`/order?status=${_orderStatus_?.cancelled}`)
                  }}
                >
                  <h3 className='fw-600 mb-0 cfz-18 badge bg-Cancelled '>
                    {data?.order?.cancelled}
                  </h3>
                  <p className='mb-0'>Cancelled</p>
                </div>

                <div
                  role='button'
                  onClick={() => navigate('/order')}
                  className='border rounded text-center badge bg-total px-2  h-100 d-flex align-items-center justify-content-center flex-column'
                >
                  <h3 className='fw-600 mb-0 cfz-24 mb-0 text-black'>
                    {data?.order?.totalOrders}
                  </h3>
                  <p className='mb-0 cfz-18 text-black'>Total</p>
                </div>
                <div
                  role='button'
                  className='pv-orderstatus-inner text-center px-2 '
                  onClick={() => {
                    navigate(`/order?status=${_orderStatus_?.partialConfirmed}`)
                  }}
                >
                  <h3 className='fw-600 mb-0 cfz-18 badge-partialconfirmed'>
                    {data?.order?.partialConfirmed}
                  </h3>
                  <p className='mb-0'>Partial Confirmed</p>
                </div>
                <div
                  role='button'
                  className='pv-orderstatus-inner text-center px-2 '
                  onClick={() => {
                    navigate(`/order?status=${_orderStatus_?.partialPacked}`)
                  }}
                >
                  <h3 className='fw-600 mb-0 cfz-18 badge badge-parcial-packed'>
                    {data?.order?.partialPacked}
                  </h3>
                  <p className='mb-0'>Partial Packed</p>
                </div>
                <div
                  role='button'
                  className='pv-orderstatus-inner text-center px-2 '
                  onClick={() => {
                    navigate(`/order?status=${_orderStatus_?.partialShipped}`)
                  }}
                >
                  <h3 className='fw-600 mb-0 cfz-18 badge badge-PartialShipped'>
                    {data?.order?.partialShipped}
                  </h3>
                  <p className='mb-0'>Partial Shipped</p>
                </div>
                <div
                  role='button'
                  className='pv-orderstatus-inner text-center px-2 '
                  onClick={() => {
                    navigate(`/order?status=${_orderStatus_?.partialDelivered}`)
                  }}
                >
                  <h3 className='fw-600 mb-0 cfz-18 badge badge-PartialDelivered'>
                    {data?.order?.partialDelivered}
                  </h3>
                  <p className='mb-0'>Partial Delivered</p>
                </div>

                <div
                  role='button'
                  className='pv-orderstatus-inner text-center px-2 '
                  onClick={() => {
                    navigate(`/order?status=${_orderStatus_?.exchanged}`)
                  }}
                >
                  <h3 className='fw-600 mb-0 cfz-18 badge bg-Exchange '>
                    {data?.order?.exchanged}
                  </h3>
                  <p className='mb-0'>Exchanged</p>
                </div>
                <div
                  role='button'
                  className='pv-orderstatus-inner text-center px-2 '
                  onClick={() => {
                    navigate(`/order?status=${_orderStatus_?.returned}`)
                  }}
                >
                  <h3 className='fw-600 mb-0 cfz-18 badge bg-Returned'>
                    {data?.order?.returned}
                  </h3>
                  <p className='mb-0'>Returned</p>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default OrderChart
